import type { ChatEntryData } from "../components/Workflow";
import { toolContentPath } from "./apiPaths";
import { serializeChatEntries } from "./serializeChatEntries";

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

async function fetchToolOutputs(
  entries: readonly ChatEntryData[],
  externalApiUrl: string
) {
  const outputs = new Map<string, unknown>();
  await Promise.all(
    entries
      .filter((e) => e.toolCall?.completedAt != null)
      .map(async (e) => {
        const res = await fetch(`${externalApiUrl}${toolContentPath(e.id)}`, {
          credentials: "include",
        });
        if (res.status === 204 || !res.ok) return;
        outputs.set(e.id, await res.json());
      })
  );
  return outputs;
}

export async function downloadChatAsJson(
  entries: readonly ChatEntryData[],
  filenameBase: string,
  externalApiUrl: string
) {
  const toolOutputs = await fetchToolOutputs(entries, externalApiUrl);
  const serialized = serializeChatEntries(entries, toolOutputs);
  downloadBlob(
    new Blob([JSON.stringify(serialized, null, 2)], {
      type: "application/json",
    }),
    `${filenameBase.replace(/[^a-z0-9]/gi, "-").toLowerCase()}.json`
  );
}
